import type { GenericValidateFunction } from 'vee-validate'
import { toValue } from '#imports'
import type { MaybeRefOrGetter } from '#imports'

export interface UseFieldValidatorOptions {
    rules: MaybeRefOrGetter<GenericValidateFunction<any>[] | undefined>
}

export const useFieldValidator = (options: UseFieldValidatorOptions) => {
    const { rules } = options

    async function runValidation(value: any, context: any) {
        const rawRules = toValue(rules)

        if (!rawRules || rawRules.length === 0) return true

        for (const rule of rawRules) {
            const result = await rule(value, context)

            if (typeof result === 'string') return result
        }

        return true
    }

    return {
        runValidation,
    }
}
